import { isEmpty, isNumber, set } from 'lodash';
import { getLastNonEmptyTierIdx, isEmptyTier } from './helpers';

export const commissionFormName = 'commissionForm';

const isMore = (a, b) => {
  if (!isNumber(a) && isNumber(b)) {
    return false;
  }

  if (isNumber(a) && !isNumber(b)) {
    return true;
  }

  return a > b;
};

const validateTiers = (tiers, fieldsForValidation) => {
  const errors = [];

  const validateTill = getLastNonEmptyTierIdx(tiers, fieldsForValidation);

  // all tiers are empty
  if (validateTill === -1) {
    return [true, errors];
  }

  tiers.forEach((item, idx) => {
    if (idx === 0) {
      return;
    }

    if (idx > validateTill) {
      errors[idx] = fieldsForValidation.reduce((memo, field) => ({
        ...memo,
        [field]: null,
      }), {});
      return;
    }

    const previousItem = tiers[idx - 1];
    if (isEmptyTier(previousItem, fieldsForValidation)) {
      errors[idx - 1] = fieldsForValidation.reduce((memo, field) => ({
        ...memo,
        [field]: 'Tier can not be empty',
      }), {});
    } else {
      errors[idx] = fieldsForValidation.reduce((memo, field) => ({
        ...memo,
        [field]: isMore(item[field], previousItem[field]) ? null : `Must be more than tier ${idx}`,
      }), {});
    }
  });

  const isValid = errors.every(error => error.amount === null && error.flatAmount === null);
  return [isValid, errors];
};

export const validate = (values) => {
  const output = {};

  if (values.serviceCommissionTiersType === 'flatAmount') {
    const [isValid, errors] = validateTiers(values.shop.commissionTiers, ['amount', 'flatAmount']);
    if (!isValid) {
      set(output, 'shop.commissionTiers', errors);
    }
  } else {
    values.barbers.forEach((barber, idx) => {
      const [isValid, errors] = validateTiers(barber.commissionTiers, ['amount', 'percentage']);
      if (!isValid) {
        set(output, `barbers[${idx}].commissionTiers`, errors);
      }
    });
  }

  if (values.productCommissionTiersType === 'flatAmount') {
    const [isValid, errors] = validateTiers(values.shop.productCommissionTiers, ['amount', 'flatAmount']);
    if (!isValid) {
      set(output, 'shop.productCommissionTiers', errors);
    }
  } else {
    values.barbers.forEach((barber, idx) => {
      const [isValid, errors] = validateTiers(barber.productCommissionTiers, ['amount', 'percentage']);
      if (!isValid) {
        set(output, `barbers[${idx}].productCommissionTiers`, errors);
      }
    });
  }

  return isEmpty(output) || output;
};
